import React from 'react';

interface ButtonProps {
    id?: string;
    title: string;
    className?: string | null;
    onClick?: () => void;
    disabled?: boolean;
    secondary?: boolean;
}

const Button = ({id = 'default-id', secondary, title, className = "", onClick, disabled = false}: ButtonProps) => {
  // Clean up the className string by removing extra spaces and null/undefined values
  const buttonClasses = [
    'btn',
    'btn-primary',
    'btn-block',
    'btn-lg',
    secondary ? 'btn-outline' : '',
    className,
  ]
    .filter(Boolean) // Remove falsy values (empty strings, null, undefined)
    .join(' ')
    .trim();

  return (
    <button 
      id={id} 
      disabled={disabled} 
      className={buttonClasses} 
      onClick={onClick}
    >
      {title}
    </button>
  )
};

export default Button